<template>
    <div>
        <el-dialog class="code_url" :visible.sync="centerDialogVisible" width="42%" center>
            <img style="width:600px;" :src="codeUrl" alt="">
            <!-- <el-image style="width:600px;" :src="codeUrl" lazy></el-image> -->
        </el-dialog>

        <p class="head_top">
            <!-- <span :class="alertsPyIfMove ? 'alerts_py_if_move' : ''" class="alerts_py" @click="currentPolitics('5e09ab7ce4b0b14aa6e2e642')" @mouseover="mouseOver('5e09ab7ce4b0b14aa6e2e642')">
                时政快讯
            </span>
            <span :class="alertsPyIfMove ? '' : 'alerts_py_if_move'" class="announcement_py" @click="announcement('5d68ce5de4b0e2963a408843')" @mouseover="mouseOver('5d68ce5de4b0e2963a408843')">
                公示公告
            </span> -->
        <ul>
            <li class="alerts_py" :class="alertsPyIfMove ? 'alerts_py_if_move' : ''"
                @click="currentPolitics('5e09ab7ce4b0b14aa6e2e642')" @mouseover="mouseOver('5e09ab7ce4b0b14aa6e2e642')">
                时政快讯</li>
            <li class="alerts_py" :class="alertsPyIfMove ? '' : 'alerts_py_if_move'"
                @click="announcement('5d68ce5de4b0e2963a408843')" @mouseover="mouseOver('5d68ce5de4b0e2963a408843')">
                公示公告</li>
        </ul>
        </p>
        <p v-if="Loading" style="text-align: center;height: 253px;line-height: 253px;"><mt-spinner
                type="triple-bounce"></mt-spinner></p>

        <div v-if="!Loading" class="head_middle" v-show="moduleIf">
            <div class="head_middle_for" v-for="(item, index) in getColumnDataList" :key="item.id"
                @click="columnData(item)">
                <p class="head_title"> <i class="el-icon-caret-right" style="color:#F8696A"></i> {{ item.title }}</p>
                <p v-for="item in absParameterJsonUrl" :key="item.id" v-if="index == item.id" class="head_con_source">
                    {{ item.pubDateMonth }}-{{ item.pubDateDay }}</p>
            </div>
        </div>

        <div v-if="!Loading" class="head_middle" v-show="!moduleIf">
            <div class="head_middle_for" v-for="(item, index) in getColumnDataLists" :key="item.id"
                @click="columnData(item)">
                <p class="head_title"> <i class="el-icon-caret-right" style="color:#F8696A"></i> {{ item.title }}</p>
                <p v-for="item in absParameterJsonUrls" :key="item.id" v-if="index == item.id" class="head_con_source">
                    {{ item.pubDateMonth }}-{{ item.pubDateDay }}</p>
            </div>
        </div>


        <p class="head_bot">
            <el-button type="text" @click="centerDialogVisiblebtn()" style="padding:0 !important">
                <img @click="" src="../images/banner2.png" alt="" style="display:block">
            </el-button>
        </p>
    </div>
</template>
<script>
import { listApi, listDetails, codeDownload, generateSign } from '@/api/index'
import Bus from '@/Bus'
const getNewsColumnData = {
    pageNum: 0,
    pageSize: 7,
    columnId: '5e09ab7ce4b0b14aa6e2e642',
    userId: "",
    appInfoId: "10"
}
const getNewsColumnDatas = {
    pageNum: 0,
    pageSize: 7,
    columnId: '5d68ce5de4b0e2963a408843',
    userId: "",
    appInfoId: "10"
}
const abstractParameter = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
export default {
    data() {
        return {
            alertsPyIfMove: true,
            Loading: true,
            codeUrl: '',
            centerDialogVisible: false,
            jumpRouting: true,
            getColumnData: Object.assign({}, getNewsColumnData),
            getColumnDatas: Object.assign({}, getNewsColumnDatas),
            getColumnDataList: null,
            getColumnDataLists: null,
            absParameter: Object.assign({}, abstractParameter),
            absParameterJsonUrl: [],
            absParameterJsonUrls: [],
            projectIdIf: '',
            moduleIf: true
        }
    },
    created() {
        this.publicAnnouncement()
        this.publicAnnouncements()
    },
    methods: {
        mouseOver(moveId) {
            if (moveId == '5e09ab7ce4b0b14aa6e2e642') {
                this.alertsPyIfMove = true
                this.moduleIf = true
            } else if (moveId == '5d68ce5de4b0e2963a408843') {
                this.alertsPyIfMove = false
                this.moduleIf = false
            }

        },
        publicAnnouncement() {
            const headers = {
                'Sign': generateSign()
            };
            this.axios.post(listApi, this.getColumnData, { headers }).then(res => {
                this.projectIdIf = this.getColumnData.columnId
                this.getColumnDataList = res.data.data[0].list.splice(0, 6)
                // this.Loading = false
                this.getColumnDataList.forEach((element, index) => {
                    let absPaUrl = {}
                    absPaUrl['id'] = index
                    absPaUrl['pubDateMonth'] = element.pubDate.split(' ')[0].split('-')[1]
                    absPaUrl['pubDateDay'] = element.pubDate.split(' ')[0].split('-')[2]
                    this.absParameterJsonUrl.push(absPaUrl)
                    this.Loading = false
                });
            })
        },
        publicAnnouncements() {
            const headers = {
                'Sign': generateSign()
            };
            this.axios.post(listApi, this.getColumnDatas, { headers }).then(res => {
                this.projectIdIf = this.getColumnDatas.columnId
                this.getColumnDataLists = res.data.data[0].list.splice(0, 6)
                // this.Loading = false
                this.getColumnDataLists.forEach((element, index) => {
                    let absPaUrl = {}
                    absPaUrl['id'] = index
                    absPaUrl['pubDateMonth'] = element.pubDate.split(' ')[0].split('-')[1]
                    absPaUrl['pubDateDay'] = element.pubDate.split(' ')[0].split('-')[2]
                    this.absParameterJsonUrls.push(absPaUrl)
                    this.Loading = false
                });
            })
        },
        // 列表详情跳转
        columnData(type) {
            let routeData = this.$router.resolve({ path: '/details', query: { id: type.id, jsonUrl: type.jsonUrl } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false);
        },
        // 公示公告
        announcement(columnId) {
            let routeData = this.$router.resolve({ path: '/announcement', query: { title: '公示公告' } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false);
        },
        // 时政快讯
        currentPolitics(columnId) {
            let routeData = this.$router.resolve({ path: '/alerts', query: { title: '时政快讯' } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false);
        },
        centerDialogVisiblebtn() {
            const headers = {
                'Sign': generateSign()
            };
            this.axios.post(codeDownload, { "appInfoId": "10" }, { headers }).then(res => {
                this.codeUrl = res.data.data[0].qrCodeUrl
                this.centerDialogVisible = true
            })

        }
    }
}
</script>
<style lang="">
.code_url .el-dialog--center .el-dialog__body{
    text-align: center !important;
}
/* .head_con .head_con_source div img{
    display:none !important;
}
.head_con .head_con_source p img{
    display:none !important;
}
.head_con .head_con_source div span img{
    display:none !important;
}
.head_con .head_con_source p span img{
    display:none !important;
}
.head_con .head_con_source{
    width:100%;
    height:20px;
    overflow: hidden;
}
.head_con .head_con_source p  span{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color:rgba(99,99,99,1);
    line-height:18px;
    font-size:12px !important;
    display:flex;
    justify-content: baseline;
}
.head_con .head_con_source div  span{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color:rgba(99,99,99,1);
    line-height:18px;
    font-size:12px !important;
    display:flex;
    justify-content: baseline;
}
.head_con .head_con_source div br{
    display:none;
}
.head_con .head_con_source span br{
    display:none;
} */

.head_middle_for{
    cursor:pointer;
}
.head_con_source{
    float: right;
    padding-left:0.2rem;
    font-size: 14px;
    color:#999;
    padding-top: 10px;
    line-height: 29px;
}
.head_con_pubDate{
    padding-left:1.2rem;
}
.shuffling_reight{
    display:inline-block;
    width:386px;
    height:330px;
    margin-left:36px;
}
.alerts_py_if_move{
    background: url(./img/hdbgon.png) no-repeat center;
    color: #fff !important;
}
.alerts_py{
    cursor:pointer;
    width: 110px;
    height: 53px;
    line-height: 41px;
    padding: 0;
    font-size: 16px;
    font-weight: bolder;
    color: rgba(0,0,0,1);
    text-align: center;
    float: left;
}
.announcement_py{
    cursor:pointer;
    width:70px;
    height:62px;
    margin-left:16px;
    padding-top:8px;
    text-align: center;
    float:left;
    display:block;
    letter-spacing:4px;
    color:rgb(197, 194, 194);
    font-size:20px;
    background:url('../images/pic2.png') no-repeat;
    background-size:100% 100%;
}
.head_top{
    height:55px;
}
.head_middle{
    min-height:253px;
}
.head_middle .head_title{
    width:300px;
    float:left;
    color:rgba(0,0,0,1);
    font-size:16px;
    padding-top:10px;
    line-height:29px;
    overflow: hidden;
    padding-right:1.2rem;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.head_middle .head_con{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color:rgba(99,99,99,1);
    line-height:21px;
    font-size:12px;
    display:flex;
    justify-content: baseline;
}
.head_bot{
    width:386px;
    height:70px;
}
.head_bot img{
    width:98%;
    height:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/shufflingRight.vue